/**
 * created by yxy
 * 采访任务列表
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent, {contentParser} from "../../../base/BaseComponent";
import {Button, DatePicker, Icon, Input, Select, Tabs, Table, Modal, Pagination} from 'antd';
import '../css/Interview.css'
import AddInterviewTasks from '../components/addInterview'
import {taskConfig} from '../taskJson/taskCreate'
import moment from 'moment';
import {uuid, formatTime, permissionCheck} from "../../../utils";
import $ from "jquery";
import Details from '../components/details'
import {systemBaseEvent} from "../../../base/baseEvent";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";

const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;
let that;

export default class InterviewTasks extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabList: [{name: '全部', id: 0}, {name: '已提交', id: 3}, {name: '已完成', id: 4}, {
                name: '进行中',
                id: 2
            }, {name: '未领取', id: 1}],
            current: '0',
            visible: true,
            count: 0,//总数
            param: {
                status: "0",
                num: 1,
                size: 10,
                keyword: "",
                taskTimeMin: "",
                taskTimeMax: "",
                createTimeMin: "",
                createTimeMax: "",
            },
            listObj: { //列表里面的选择项
                currentStatus: '任务时间',//任务时间还是创建时间
                startTime: '', //开始时间
                endTime: ''//结束时间
            },
            timeParams: [],//选择时间后的参数拼接
            addInterviewTasksKey: uuid(),
            detailsKey:uuid(),
        };

    }

    componentWillMount() {
        let that = this;
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                that.getList()
            }
        }, "InterviewTasks")
    }


    componentDidMount() {

        this.state.param = taskConfig[this.props.taskName].param;
        contentParser(this.state.param, window);
        this.state.columns = taskConfig[this.props.taskName].columns;
        // this.setState({}, () => {
        //     this.getList()
        // });
        //选题转为任务
        systemBaseEvent.registerBaseEvent("interviewAdd", (data = {}) => {
            if (this.addInterview) {
                this.addInterview.addTask(data);
                systemBaseEvent.playbackRecorder.remove("interviewAdd");//弹出了之后需要移除一下，避免下次进来直接就弹出来了
            }
        });
        //查看选题
        systemBaseEvent.registerBaseEvent("taskView", (data = {}) => {
            if (this.details) {
                this.details.show(data);
                systemBaseEvent.playbackRecorder.remove("taskView");
            }
        });
        that=this;
        this.onChangeTabs('0')
    }

    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("InterviewTasks")
        this.init()
    }

    render() {

        return (
            <div style={{background: '#fff', borderRadius: '0px 5px 5px 5px'}}
                 id={'InterviewTasks'}>
                {this.renderBtn()}
                {this.renderTab()}
                {this.renderData()}
                <AddInterviewTasks key={this.state.addInterviewTasksKey}
                                   ref={(addInterview) => {this.addInterview = addInterview}}
                                   callBack={() => {this.init()}}>
                </AddInterviewTasks>
                <Details key={this.state.detailsKey}
                         ref={(details) => {this.details = details}}
                         callBack={() => {
                              this.init()
                        }}>
                </Details>
            </div>

        )
    }

    renderBtn() {
        return (
            <div id={'interListTop'} style={{
                padding: '24px 30px 0px 30px',
                paddingTop: '24px',
                display: 'flex',
                justifyContent: " space-between"
            }}>
                <div style={{ flex: "2 1 88px", marginRight:24}}>
                    {this.permissionCheck("interviewTask_creator") ? <Button type="primary" onClick={() => {
                        this.setState({addInterviewTasksKey: uuid()}, () => {
                            this.addInterview.show(null,'新建')
                        })
                    }}>新建任务</Button> : null}

                </div>
                <div style={{ flex: "3 1", display: "inline-flex", justifyContent: "end" }}>
                    <div style={{ flex: "1 1 224px", maxWidth: "240px", minWidth: "150px"}}>
                        <Search
                            placeholder="请输入搜索内容"
                            // value={this.state.param.keyword}
                            allowClear={true}
                            // onChange={(e) => {
                            //     this.state.param.keyword = e.target.value;
                            //     this.setState({})
                            // }}
                            onSearch={value => {
                                this.state.param.keyword = value;
                                this.state.param.num = 1;
                                this.state.param.size = 10;
                                this.setState({}, () => {
                                    this.getList()
                                })
                            }}
                            style={{width: "100%"}}
                        />
                    </div>
                    <Select value={this.state.listObj.currentStatus} style={{marginLeft: '24px', width: 110}}
                            onChange={(value) => {
                                this.state.listObj.currentStatus = value;
                                this.state.listObj.endTime = '';
                                this.state.listObj.startTime = '';
                                this.setState({})
                            }}>
                        <Option value="任务时间">任务时间</Option>
                        <Option value="创建时间">创建时间</Option>
                    </Select>
                    <RangePicker
                        value={[this.state.listObj.startTime ? moment(this.state.listObj.startTime) : undefined,
                            this.state.listObj.endTime ? moment(this.state.listObj.endTime) : undefined]}
                        format="YYYY-MM-DD HH:mm"
                        allowClear
                        style={{marginLeft: '8px',minWidth: "280px", flex: "1 1 315px"}}
                        placeholder={['开始时间', '结束时间']}
                        onChange={(date, dateString) => {
                            if (date[0] && date[1]) {
                                this.state.listObj.startTime = date[0].hours(0).minutes(0).seconds(0).toDate().getTime();
                                this.state.listObj.endTime = date[1].hours(23).minutes(59).seconds(59).toDate().getTime();
                            } else {
                                this.state.listObj.startTime = '';
                                this.state.listObj.endTime = '';
                            }
                            this.state.param.num = 1;
                            this.state.param.size = 10;
                            this.setState({}, () => {
                                this.timeCallBack()
                            })
                        }}
                    />
                    <Button id={'interListReset'} style={{marginLeft: '24px'}} onClick={() => {
                        this.init()
                    }}>重置</Button>
                </div>

                <style>
                    {`
                        #interListTop .ant-input{background:rgba(0, 80, 179, 0.04)}
                        #interListTop .ant-select-selection--single{background:rgba(0, 80, 179, 0.04)}
                        #interListTop #interListReset span{color:#0050B3}
                    `}
                </style>
            </div>

        )
    }

    renderTab() {
        const tabList =taskConfig[this.props.taskName].tabList;
        let renderTabList = []; //渲染页签节点数组
        if (tabList&&Array.isArray(tabList)) {
            tabList.forEach((item,index)=>{
                if (item.auth&&Array.isArray(item.auth)&&item.auth?.some(auth=>this.permissionCheck(auth))) {
                    renderTabList.push(<TabPane tab={item.name} key={item.id} style={{paddingLeft: 30}}></TabPane>)
                }
            })
        }
        return (
            <div id={'interListTab'}>
                <Tabs activeKey={this.state.current} onChange={(e) => {
                    this.onChangeTabs(e)
                }}>
                    {renderTabList.map((item, index) => {
                        return item;
                    })}
                </Tabs>
                <style>
                    {`#interListTab .ant-tabs-top-bar .ant-tabs-nav-container .ant-tabs-nav-animated{padding-left:30px} `}
                </style>
            </div>
        )
    }

    //选择时间
    timeCallBack() {
        if (this.state.listObj.startTime !== '') {
            if (this.state.listObj.currentStatus === '任务时间') {
                this.state.param.createTimeMin = "";
                this.state.param.createTimeMax ="";
                this.state.param.taskTimeMin = this.state.listObj.startTime;
                this.state.param.taskTimeMax = this.state.listObj.endTime;
            } else {
                this.state.param.createTimeMin = this.state.listObj.startTime;
                this.state.param.createTimeMax = this.state.listObj.endTime;
                this.state.param.taskTimeMin = "";
                this.state.param.taskTimeMax = "";
            }
        }
        this.setState({}, () => {
            this.getList()
        })
    }

    //切换列表
    onChangeTabs(e) {
        if (e === '全部') {
            if (!permissionCheck("interview_accept")) {
                // this.state.param.params = [
                //     {
                //         "type": "or",
                //         "params": [
                //             {
                //                 "key": "status",
                //                 "opt": "ne",
                //                 "val": "草稿"
                //             },
                //             {
                //                 "type": "and",
                //                 "params": [
                //                     {
                //                         "key": "status",
                //                         "opt": "eq",
                //                         "val": "草稿"
                //                     },
                //                     {
                //                         "key": "publisher.id",
                //                         "opt": "eq",
                //                         "val": window.top.currentUser.id
                //                     }
                //                 ]
                //             }
                //         ]
                //     }
                // ]
            }else{
                // this.state.param.params = [{
                //     "key": "reporter.currentDept.id",
                //     "opt": "eq",
                //     "val":window.top.currentUser.defaultInfo.dept.id,
                // },
                //     {
                //         "key": "taskObj.status",
                //         "opt": "ne",
                //         "val": "草稿"
                //     },
                //     {
                //         "key": "reporter.account",
                //         "opt": "eq",
                //         "val": window.top.currentUser.account

                //     }
                // ]
            }


        } else {
          if (permissionCheck("interview_accept")) {
        //       this.state.param.params=[
        //           {
        //               "key": "reporter.currentDept.id",
        //               "opt": "eq",
        //               "val":window.top.currentUser.defaultInfo.dept.id,
        //   },
        //       {
        //           "key": "taskObj.status",
        //           "opt": "ne",
        //           "val": "草稿"
        //       },
        //       {
        //           "key": "status",
        //           "opt": "eq",
        //           "val": e,
        //       },
        //       {
        //           "key": "reporter.account",
        //           "opt": "eq",
        //           "val": window.top.currentUser.account
        //       }
        //   ]
          }else{
            //   this.state.param.params=[{
            //       val:e,
            //       opt: 'eq',
            //       key:'status'
            //   }]
          }

        }
        this.state.current = e;
        this.state.param.status =e;
        this.state.param.num =1;
        this.state.param.size =10;
        this.setState({}, () => {
            this.getList()
        })
    }

    //重置按钮
    init=()=> {
        this.state.param.num = 1;
        this.state.param.size = 10;
        this.state.param.keyword = '';
        this.state.listObj.currentStatus = '任务时间';
        this.state.listObj.startTime = '';
        this.state.listObj.endTime = '';
        this.state.param.createTimeMin = "";
        this.state.param.createTimeMax = "";
        this.state.param.taskTimeMin = "";
        this.state.param.taskTimeMax = "";
        this.state.param.dept = ""
        this.state.timeParams = [];
        this.setState({}, () => {
            this.getList()
        })
    }

    renderData() {
        const columns = this.state.columns;
        const dataSource = this.state.dataSource;
        let newColumns = [];
        let that = this;
        columns && columns.length && columns.forEach((item, index) => {
            let extend = item.renderComponent;
            if (extend) {
                let regx = /^\$\{renderExtend\.([^.}]*)\}$/;
                if (regx.test(extend)) {
                    let renderExtendComponentName = extend.replace(regx, "$1");

                    try {
                        let RenderExtendComponent = require(`../columnRender/${renderExtendComponentName}`).default;
                        delete item.renderComponent;
                        item.render = (text, record) => <RenderExtendComponent {...item} record={record} text={text}
                                                                               tableComponent={that}/>
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
            newColumns.push(item)
        });
        dataSource && dataSource.length && dataSource.forEach((item) => {
            newColumns && newColumns.map(column => {
                if (column.dateTime) {
                    let _formatTime = formatTime;
                    try {
                        eval(`item.${column.dataIndex} = _formatTime(item.${column.dataIndex})`)
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        });
        return (
            <div>
                <Scrollbars
                    autoHeight={true}
                    autoHeightMax={616}
                >
                    <BaseTable dataSource={dataSource} columns={columns} pagination={false}
                               style={{padding: '24px 30px'}}/>
                </Scrollbars>
                {this.state.count > 0 ? <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: '80px',
                    borderTop: '1px solid #e8e8e8',
                    padding: '24px 30px 24px 0px'
                }}>
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        current={this.state.param.num}
                        pageSize={this.state.param.size}
                        total={this.state.count}
                        showTotal={total => `共 ${total} 条`}
                        onChange={(page, pageSize) => {
                            this.onChangePage(page, pageSize)
                        }}
                        onShowSizeChange={(page, pageSize) => {
                            this.onChangePage(page, pageSize)
                        }}
                    /></div> : null}
            </div>
        )
    }

    parseListBtn(record) {
        let res = [];
        if (taskConfig[this.props.taskName].listOpBtns) {
            contentParser(taskConfig[this.props.taskName].listOpBtns, {component: this});
            let btns = taskConfig[this.props.taskName].listOpBtns;
            // if (this.permissionCheck("interview_accept")) {
            //     res.push({
            //         "name": "查看",
            //         "condition": [
            //             "已提交",
            //             "进行中",
            //             "已完成",
            //             "未领取",
            //         ],
            //         "onOk":this.receiverView
            //     })
            // } 
            if(this.permissionCheck("interviewTask_creator") || this.permissionCheck("interview_accept")) {
                for (let i = 0; btns && i < btns.length; i++) {
                    let btn = btns[i];
                        res.push(btn);
                }
            }
        }
        return res;
    }

    //翻页
    onChangePage = (page, pageSize) => {
        this.state.param.num = page;
        this.state.param.size = pageSize;
        this.setState({}, () => {
            this.getList()
        })
    };
    //编辑
    edit = (data) => {
        that.setState({addInterviewTasksKey: uuid()}, () => {
            that.addInterview.show(data,'修改')
        })
    };
    //查看
    view = (data) => {
        that.setState({detailsKey:uuid()},()=>{
            that.details.show(data, taskConfig[this.props.taskName].TableList)
        })
    };
    //
    receiverView = (id, name, data) => {
        that.setState({detailsKey:uuid()},()=>{
            // that.details.show(data.id, taskConfig[this.props.taskName].TableList)
            that.details.show(data.id, taskConfig["receiverTask"].TableList)
        })
    };
    //删除
    delete = (data) => {
        Modal.confirm({
            content: "确定删除该数据",
            onOk: () => {
                let url = '/cm-sites-business/bd/busTask/delete/';
                this.request({
                    url: "" + url + data,
                    method: "post",
                    contentType: 'json',
                    callBack: (data) => {
                        this.getList()
                    }
                });
            },
            onCancel() {
            },
        });
    };

    //获取列表
    getList() {
        let {param, timeParams} = this.state;
        let newParam = JSON.parse(JSON.stringify(param));
        for (let key of Object.keys(newParam)) {
            if (newParam[key] === null || newParam[key] === '') {
                delete newParam[key];
            }
        }
        this.request({
            // url: taskConfig[this.props.taskName].url,
            url: "/cm-sites-business/bdHandler/getBusTask/page",
            method: "post",
            body: newParam,
            contentType: 'json',
            callBack: (data) => {
                let dataSource = [];
                if (data) {
                    this.state.count = data.count;
                    dataSource = data.data;
                    this.state.dataSource = dataSource;
                    this.setState({}, () => {
                        $('.ant-pagination-options-quick-jumper').find('input').val('')
                    })
                }
            }
        });
    }



}
